import React from 'react';
import PostImageTemplate from "../../../components/pages/grid/PostImageTemplate/PostImageTemplate";

const PostImageTemplateGridPage = () => {
    return <PostImageTemplate />
};

export default PostImageTemplateGridPage;
